import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { OrderQuery as OrderQueryType, OrderQueryVariables } from "gql/types/queries/OrderQuery";

const text = gql`query OrderQuery($orderInput: QueryOrderInput!) {
	order(orderInput: $orderInput) {
		id
		orderStatus
		orderType {
			orderType
			priceCents
		}
		orderNumber
		orderSubTotalCents
		discount
		taxCents
		tipCents
		orderTotalCents
		taxRate

		customer {
			fullName
			displayPhoneNumber
		}

		deliveryAddress {
			address1
			address2
			address3
			city
			state
			postalCode
		}

		phoneNumber
		displayPhoneNumber

		user {
			email
		}

		payment {
			id

			card {
				brand
				last4
			}
		}

		business {
			id
			slug
			name
			localeNames
			locales
			taxRate

			address {
				address1
				address2
				address3
				city
				state
				postalCode
				country
				coordinates {
					latitude
					longitude
				}
			}

			categories {
				id
				name
				localeNames
			}
		}

		orderItems {
			id
			quantity
			unitPriceCents
			extendedPriceCents

			menuItem {
				id
				itemCode
				name
				localeNames
				description
				priceCents
				displayPrice
				imageUrl
			}

			selectedMenuItemOptionGroups {
				menuItemOptionGroupId
				name
				localeNames

				selectedMenuItemOptions {
					menuItemOptionId
					name
					localeNames
					priceCents
					displayPrice
				}
			}
		}
	}
}
`;

const OrderQuery: IOperation<OrderQueryType, OrderQueryVariables> = { text } as any;

export default OrderQuery;
